import { useCallback } from 'react'
import { useQuery } from '@maui/react-query'
import { useMatiApiClient } from './client'
import { transformTimelineData } from '../../utils/helpers'

const adapters = [
  ['default', transformTimelineData],
  ['__raw', data => data]
]

export const campaignTimelineQueryFn = async ({ id, api }) => {
  const data = await api.fetchCampaignTimeline(id)
  const adaptedData = await Promise.all(adapters.map(([key, adapter]) => {
    return adapter(data)
  }))
  return adaptedData.reduce((acc, curr, i) => {
    acc[adapters[i][0]] = curr
    return acc
  }, {})
}

export const useCampaignQuery = (id, options = {}) => {
  const api = useMatiApiClient('campaigns')
  return useQuery({
    queryFn: () => api.fetchCampaign(id),
    queryKey: ['campaigns', id],
    ...options
  })
}

export const useTopCampaignQuery = (filters, options = {}) => {
  const api = useMatiApiClient('campaigns')
  const body = { ...filters, limit: 1 }

  return useQuery({
    queryFn: () => api.fetchTopCampaign(body),
    queryKey: ['topCampaign', filters, body],
    ...options
  })
}

export const useCampaignByEndpointQuery = ({ endpoint, filters, limit }, options = {}) => {
  const api = useMatiApiClient('campaigns')
  const body = { ...filters, limit }

  return useQuery({
    queryFn: () => api.fetchCampaignByEndpoint({ endpoint, body }),
    queryKey: ['campaignByEndpoint', endpoint, body],
    ...options
  })
}

export const useCampaignVocabService = (options = {}) => {
  const api = useMatiApiClient('campaigns')
  return useQuery({
    queryFn: () => api.fetchVocab(),
    queryKey: ['campaignsVocab'],
    ...options
  })
}

export const useCampaignTimelineFetch = (id, options = {}) => {
  const api = useMatiApiClient('campaigns')
  const { adapter = false, ...restOptions } = options
  const adapterFn = adapters.find(([key]) => key === adapter || (adapter === true && key === 'default') || (adapter === false && key === '__raw'))

  return useQuery({
    queryFn: () => campaignTimelineQueryFn({ id, api }),
    queryKey: ['campaignTimeline', id],
    select: useCallback(data => data[adapterFn[0]] || data.__raw, [adapterFn]),
    ...restOptions
  })
}

export const useCampaignAttackPatternFetch = (id, options = {}) => {
  const api = useMatiApiClient('campaigns')
  return useQuery({
    queryFn: () => api.fetchAttackPatterns(id),
    queryKey: ['campaignAttackPattern', id],
    ...options
  })
}
